import React from 'react';
import { TabGroup, TabList, Tab } from "@utahdts/utah-design-system";

const DwriTabs = ({ activeTab, onTabChange }) => {
    return (
        <TabGroup value={activeTab} onChange={onTabChange}>
            <TabList>
                <Tab id="dwri-data">DWRi Data</Tab>
                <Tab id="calculations">Calculations</Tab>
                <Tab id="report">Report</Tab>
            </TabList>
        </TabGroup>
    );
};

export default DwriTabs;